import {TYPES} from '../Actions/qrCodeAction';
import * as moment from 'moment';

const qrCodeReducer = (state = {}, action) => {
    switch (action.type) {
        case TYPES.FETCH_QR_CODE_SUCCESS:
            return {
                ...state,
                qrCode: {
                    value: action.qrCode,
                    updatedAt: moment()
                }
            };
        default:
            return state;
    }
};

export default qrCodeReducer;



// WEBPACK FOOTER //
// ./src/ReduxRequests/Reducer/qrCodeReducer.ts